import { bindEvent } from 'vtils'
import {
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUpdated,
  reactive,
  ref,
} from '@vue/composition-api'
import { pxToRpx } from '@/utils'
import { useContext } from './use_context'

export function useFold(options: {
  container: string
  trigger: string
  height: number
}) {
  const ctx = useContext()

  const fold = reactive({
    canFold: false,
    isFold: true,
  })

  const off = ref<() => void>()

  const process = () => {
    off.value?.()

    const containerEl = ctx.$refs[options.container] as HTMLDivElement
    const height = containerEl.clientHeight
    const targetHeight = pxToRpx(options.height)

    if (!fold.canFold) {
      fold.canFold = height > targetHeight
    }
    if (fold.canFold && !containerEl.dataset.foldReady) {
      containerEl.dataset.foldReady = '1'
      containerEl.style.height = `${targetHeight}px`
      containerEl.style.overflow = 'hidden'
    }

    nextTick(() => {
      const triggerEl = ctx.$refs[options.trigger] as HTMLDivElement
      off.value = bindEvent(triggerEl)(
        'click',
        () => {
          fold.isFold = !fold.isFold
          containerEl.style.height = fold.isFold ? `${targetHeight}px` : 'auto'
          containerEl.style.overflow = fold.isFold ? 'hidden' : 'auto'
        },
        {
          passive: false,
        },
      )
    })
  }

  onMounted(process)

  onUpdated(process)

  onBeforeUnmount(() => off.value?.())

  return fold
}
